var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{staticClass:"status-icon",class:[ _vm.iconClass, {'inverted': _vm.inverted} ]},[_vm._v(" "+_vm._s(_vm.statusIcon)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }